import React, { useState } from 'react';
import { Container, Box, TextField, Button, Typography, Alert, Divider, Link } from '@mui/material';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import GoogleIcon from '@mui/icons-material/Google';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';

export default function RegisterPage() {
  const { register, loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', password: '', confirm: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);

  const handleChange = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password !== form.confirm) return setError('Le password non coincidono');
    if (form.password.length < 6) return setError('La password deve essere di almeno 6 caratteri');
    setLoading(true);
    try {
      await register(form.email, form.password, form.name);
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Errore durante la registrazione');
    } finally {
      setLoading(false);
    }
  };

  const googleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      setGoogleLoading(true);
      setError('');
      try {
        const { data: userInfo } = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        });
        const user = await loginWithGoogle(userInfo.email, userInfo.name, userInfo.sub);
        navigate(user.role === 'admin' ? '/admin' : '/', { replace: true });
      } catch {
        setError('Errore durante la registrazione con Google');
      } finally {
        setGoogleLoading(false);
      }
    },
    onError: () => setError('Registrazione Google annullata o non riuscita'),
  });

  return (
    <Container maxWidth="xs" sx={{ pt: 8, pb: 4 }}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>Crea account</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Hai già un account?{' '}
        <Link component={RouterLink} to="/accedi">Accedi</Link>
      </Typography>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <Button
        fullWidth variant="outlined" size="large"
        startIcon={<GoogleIcon />}
        onClick={() => googleLogin()}
        disabled={googleLoading}
        sx={{ mb: 3 }}
      >
        {googleLoading ? 'Attendere...' : 'Registrati con Google'}
      </Button>

      <Divider sx={{ mb: 3 }}>oppure con email</Divider>

      <Box component="form" onSubmit={handleSubmit}>
        <TextField fullWidth label="Nome" name="name" value={form.name}
          onChange={handleChange} sx={{ mb: 2 }} autoComplete="name" />
        <TextField fullWidth label="Email" name="email" type="email" value={form.email}
          onChange={handleChange} sx={{ mb: 2 }} required autoComplete="email" />
        <TextField fullWidth label="Password" name="password" type="password" value={form.password}
          onChange={handleChange} sx={{ mb: 2 }} required />
        <TextField fullWidth label="Conferma password" name="confirm" type="password" value={form.confirm}
          onChange={handleChange} sx={{ mb: 3 }} required />
        <Button fullWidth type="submit" variant="contained" size="large" disabled={loading}>
          {loading ? 'Registrazione...' : 'Registrati'}
        </Button>
      </Box>
    </Container>
  );
}
